// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3qchi","box":"WorkspacesBox_box__dj4D0","node":"WorkspacesBox_node__-9cde"};